<div class="partner-wrapper">
  <div class="hero card-glass mb-4">
    <div class="crumb">
      <a routerLink="/utilisateur/partenaire/dashboard" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au dashboard partenaire</a>
    </div>
    <p class="eyebrow">Spay · Partenaire</p>
    <h1>Ajouter des employés</h1>
    <p class="lead">Créez des accès dédiés pour vos collaborateurs en quelques clics.</p>
  </div>

  <div class="row g-3">
    <div class="col-lg-6">
      <div class="card card-glass p-3 h-100">
        <h5 class="mb-3">Nouveau compte employé</h5>
        <p *ngIf="added" class="text-success">Élément ajouté.</p>
        <form [formGroup]="PartenaireForm" #f="ngForm" (ngSubmit)="addCaissier(f.value)" class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nom</label>
            <input formControlName="firstName" name="firstName" #firstName (blur)="generateEmail(firstName.value)" class="form-control" type="text" required>
            <small *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="text-danger">Au moins 3 caractères</small>
          </div>
          <div class="col-md-6">
            <label class="form-label">Prénom</label>
            <input formControlName="lastName" name="lastName" class="form-control" type="text" required>
            <small *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="text-danger">Au moins 3 caractères</small>
          </div>

          <div class="col-12">
            <label class="form-label">Email de connexion</label>
            <input formControlName='email' #emaild (blur)="isEmail(emaild.value)" name="email" class="form-control" type="email" required readonly>
            <small *ngIf="email.invalid  && (email.dirty || email.touched)" class="text-danger">Email invalide</small>
            <small *ngIf="emailexist && email.valid" class="text-danger">Email déjà utilisé</small>
          </div>

          <div class="col-12">
            <label class="form-label">Rôle employé</label>
            <select formControlName="employeeRole" class="form-select" required>
              <option *ngFor="let role of availableEmployeeRoles" [value]="role.value">{{role.label}}</option>
            </select>
            <small *ngIf="employeeRole.invalid && (employeeRole.dirty || employeeRole.touched)" class="text-danger">Choisissez un rôle</small>
          </div>

          <div class="col-md-6">
            <label class="form-label">Mot de passe</label>
            <input formControlName="password" #pass (focus)="showvalidationpart()" (blur)="hidevalidationpart()" (keyup)="validateValue(pass.value)" name="password" class="form-control" type="password" id="pass" required>
            <small *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">Mot de passe invalide</small>
            <div *ngIf="validation" class="password-hints mt-1">
              <p [ngStyle]="{'color':letterchange ? 'lightgreen' : '#ff9b9b' }">Minuscule</p>
              <p [ngStyle]="{'color':capitalchange ? 'lightgreen' : '#ff9b9b' }">Majuscule</p>
              <p [ngStyle]="{'color':numberchange ? 'lightgreen' : '#ff9b9b' }">Chiffre</p>
              <p [ngStyle]="{'color':symbolechange ? 'lightgreen' : '#ff9b9b' }">Symbole</p>
              <p [ngStyle]="{'color':lengthchange ? 'lightgreen' : '#ff9b9b' }">8-16 caractères</p>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Confirmer le mot de passe</label>
            <input formControlName="confirmPassword" name="confirmPassword" class="form-control" type="password" required>
            <small *ngIf="confirmPassword.invalid && (confirmPassword.dirty|| confirmPassword.touched)" class="text-danger">Mot de passe invalide</small>
          </div>

          <div class="col-12 d-grid">
            <button type="submit" class="btn btn-primary btn-pill" [disabled]="!PartenaireForm.valid || phonexist">Terminé</button>
          </div>
        </form>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="card card-glass p-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Liste des employés ajoutés</h5>
        </div>
        <div class="table-responsive">
          <table class="table table-borderless align-middle text-light">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Email</th>
                <th>Matricule</th>
                <th>Rôle</th>
                <th colspan="2" class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of caisierlist">
                <td>{{c.firstName}}</td>
                <td>{{c.lastName}}</td>
                <td>{{c.username}}</td>
                <td>{{c.matriculeEmploye || '-'}}</td>
                <td>{{roleLabel(extractEmployeeRole(c))}}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-outline-light btn-sm" (click)="editer(c.id,c)"><i class="bi bi-pencil-square me-1"></i><span class="d-none d-sm-inline">Éditer</span></button>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-outline-danger btn-sm" disabled><i class="bi bi-trash me-1"></i><span class="d-none d-sm-inline">Suppr</span></button>
                </td>
              </tr>
              <tr *ngIf="!caisierlist || caisierlist.length === 0">
                <td colspan="7" class="text-center text-muted">Aucun employé ajouté.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
